import { DateTime } from "luxon";

/*
Input: 1665806400 (timestamp in seconds)
Output: "2022-08-15" (YYYY-MM-DD)
*/

export function formatTimestampToSQLDate(timestamp) {
  if (!timestamp) return "N/A";

  return DateTime.fromSeconds(timestamp).toUTC().toSQLDate();
}
